import Collapse from '@mui/material/Collapse'
import * as React from 'react'
import { useClosingReqContext } from '../../context'
import type { Requirement } from '../../typings'

type Props = {
  requirement: Requirement
  children: JSX.Element
}

export function AnimationHandler(props: Props) {
  const { requirement, children } = props
  const [{ activeRequirement, transition }] = useClosingReqContext()

  return (
    <Collapse
      unmountOnExit
      exit={transition}
      enter={transition}
      in={requirement === activeRequirement}
    >
      {children}
    </Collapse>
  )
}
